import { Component } from '@angular/core';
import { Category } from '../../../app/app.interfaces';
import { CategoryService } from '../../../services/category.service';

@Component({
  selector: 'category-list',
  templateUrl: 'category-list.html'
})
export class CategoryList {

  categories: Category[] = [];

  constructor(private categoryService: CategoryService) {
    this.categoryService.getAllCategories().then((categories: Category[]) => {
      this.categories = categories;
    });
  }
}



// WEBPACK FOOTER //
// ./src/partials/category/category-list/category-list.ts